export const LanguageConstants = {
    "en": {
        "sitesDashboard": "Sites Dashboard",
        "alertsConfigurations": "Alerts Configurations",
        "counters": "Counters",
        "configuration": "System Configuration",
        "reports": "Reports",
        "payments": "Payments",
        "subscribers": "Subscribers",
        "vehiclesInsite": "vehicles insite",

        "fastPark": "FastPark",

        "readAllNewMessages": "Read All New Messages",
        "viewAll": "View All",
        "settings": "Settings",
        "login": "Login",
        "logout": "Logout",
        "password": "password",
        "income": "Income",
        "connection": "Connection",
        "configure": "Configure",
        "active": "Active",
        "notActive": "Not active",
        "vehicles": "Vehicles",
        "alarms": "Alarms",
        "transactions": "Transactions",
        "view": "View",
        "search": "Search",
        "searchNameEmailPhone": "Search by name, email or phone",

        "users": "Users",
        "email": "Email",
        "phone": "Phone",
        "eventsAlertsFor": "Events Alerts for",
        "id": "ID",
        "name": "Name",
        "description": "Description",
        "severity": "Severity",
        "severityDescription": "Severity Description",
        "typeID": "Type ID",
        "typeDescription": "Type Description",
        "module": "Module",
        "displayUI": "Display UI",
        "playSound": "Play sound",
        "sendEmail": "Send Email",
        "sendSMS": "Send SMS",
        "lastUpdate": "Last Update",

        "firstName": "First Name",
        "lastName": "Last Name",
        "save": "Save",
        "confirm": "Confirm",
        "back": "Back",
        "cancel": "Cancel",
        "toMainPage": "To Main Page",

        "carNumber": "car number",
        "datetime": "datetime",
        "companyName": "company name",

        "sites": "Sites",
        "reportType": "Report type",
        "download": "download",
        "all": "all",

        "from": "from",
        "to": "to",

        "deleteItemUserConfirmationPopupHeader": "This item will be deleted.",
        "deleteItemUserConfirmationPopupText": "Are sure ?",

        "paymentsArray": {
            "cash": "cash",
            "name": "name",
            "nameLoc": "nameLoc",
            "nameLoc2": "nameLoc2",
        },

        "subscribersArray": {
            "z": "z",
            "price": "price",
            "profile": "profile",
            "ticket": "ticket",
            "dateExit": "datetime exit",
            "dateEntry": "datetime entry",
            "timeSpent": "time spent",
            "companyName": "company name",
            "companyId": "company id",
            "carNumber": "car number",
            "lastName": "last name",
            "firstName": "first name",
            "type": "subscriber type",
            "inside": "bool inside",
            "sitename": "sitename",
            "siteId": "site id"
        },

        "guestsArray": {
            "identityNumber": "identity number",
            "guestId": "guest id",
            "userId": "subscription id",
            "lastName": "last name",
            "firstName": "first name",
            "carNumber": "car number",
            "carNumber2": "second car",
            "reserved": "reserved",
            "startDate": "start date",
            "finishDate": "finish date",
            "inside": "inside",


            "savedSubscription": "",
            "forSubscription": "",
            "forGuests": "",
            "available": "",
            "reservedd": "",

            "guestTab": "",
            "subscriptionsTab": "",

            "company": ""
        },


        "guestsSubsArray": {
            "name": "First Name",
            "lastName": "Last Name",
            "lprNumber": "LPR Number",
            "startDate": "Start Data",
            "endDate": "End Date",
            "passportNumber": "Passport Number",
            "companyID": "Company ID",
            "title": "Title"
        },

        "insiteArray": {
            "inside": "inside",
            "free": "free places",
            "whole": "whole",
            "transients": "transients",
            "subscribers": "subscribers",
            "guests": "guests",
            "manuallyOpen": "Manually Open",

            "tag": "tag number",
        },

        "languages": {
            "en": "English",
            "he": "Hebrew"
        },

        "errors": {
            "saveSuccess": "Saved Successfully",
            "saveError": "Error while saving",
            "connectionError": "Error connecting to server",
            "nameError": "Name is incorrect",
            "emailError": "Email is incorrect",
            "phoneError": "Phone is incorrect",
        },
        "calendar": {
            "previousMonth": "Previous Month",
            "nextMonth": "Next Month",
            "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "weekdays": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "weekdaysShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
        },
        "getTickets": "Get tickets",
        "virtualValidation": "Virtual Validation",
        "validateTicket": "Validate Ticket",
        "entryTicketNumber": "Entry ticket",
        "transientID": "Transient ID",
        "virtualTicket": "Virtual Ticket",

        "menuSearch": "Menu search",

    },
    "he": {
        "sitesDashboard": "Sites Dashboard HE",
        "alertsConfigurations": "הגדרות התראות",
        "counters": "רכבים בחניון",
        "configuration": "הגדרות מערכת",
        "reports": "דוחות",
        "payments": "payments",
        "vehiclesInsite": "vehicles insite",

        "fastPark": "FastPark",

        "readAllNewMessages": "Read All New Messages",
        "viewAll": "הצדג הכל",
        "settings": "הגדרות",
        "login": "התחבר",
        "logout": "יציאה",
        "password": "סיסמה",
        "income": "הכנסות",
        "connection": "חיבור",
        "configure": "Configure",
        "active": "פעיל",
        "notActive": "אינו פעיל",
        "vehicles": "רכבים",
        "alarms": "התראות",
        "transactions": "תנועות",
        "view": "הצג",
        "search": "חיפוש",
        "searchNameEmailPhone": "חפש",

        "users": "משתמשים",
        "email": "כתובת מייל",
        "phone": "טלפון",
        "eventsAlertsFor": "התראות עבור משתמש",
        "id": "מס",
        "name": "שם",
        "description": "תיאור",
        "severity": "חומרה",
        "severityDescription": "תיאור רמת חומרה",
        "typeID": "סוג התראה",
        "typeDescription": "תיאור סוג התראה",

        "module": "מודול",
        "displayUI": "הצג",
        "playSound": "השמיע צליל",
        "sendEmail": "שלח מייל",
        "sendSMS": "שלח SMS",
        "lastUpdate": "עדכון אחרון",


        "firstName": "שם",
        "lastName": "שם משפחה",
        "save": "שמור",
        "confirm": "אשר",
        "back": "חזור",
        "cancel": "בטל",
        "toMainPage": "לעמוד ראשי",

        "sites": "אתרים",
        "reportType": "סוג דוח",
        "download": "הורדה",
        "all": "הכל",

        "from": "מ-",
        "to": "עד-",

        "deleteItemUserConfirmationPopupHeader": "פריט זה ימחק.",
        "deleteItemUserConfirmationPopupText": "האם להמשיך?",

        "paymentsArray": {
            "cash": "cash",
            "name": "name",
            "nameLoc": "nameLoc",
            "nameLoc2": "nameLoc2",
        },

        "subscribersArray": {
            "z": "z",
            "price": "מחיר",
            "profile": "פרופיל",
            "ticket": "כרטיס",
            "dateExit": "תאריך יציאה",
            "dateEntry": "תאריך כניסה",
            "timeSpent": "משך שהייה",
            "companyName": "שם חברה",
            "companyId": "מס' חברה",
            "carNumber": "מס' רכב",
            "lastName": "שם משפחה",
            "firstName": "שם פרטי",
            "type": "סוג מנוי",
            "inside": "בחניון",
            "sitename": "שם אתר",
            "siteId": "מס' אתר"
        },

        "guestsArray": {
            "identityNumber": "ת''ז",
            "guestId": "מס' אורח",
            "userId": "שם משתמש",
            "lastName": "שם משפחה",
            "firstName": "שם פרטי",
            "carNumber": "מס' רכב",
            "carNumber2": "מס' רכב שני",
            "reserved": "שמור",
            "startDate": "תאריך תחילת תוקף",
            "finishDate": "תאריך סיום תוקף",
            "inside": "בחניון",

            "constSubscribersCount": "כמות מנויים שמורים בחניון",
            "subscribersCount": "כמות מנויים בחניון ללא שמורים",
            "guestsCount": "כמות אורחים בחניון",
            "available": "מקומות פנויים",
            "reservedPlaces": "כמות מנויים שמורים",

            "guestTab": "אורחים",
            "subscriptionsTab": "מנויים",

            "company": "חברה"
        },
        "guestsSubsArray": {
            "name": "שם",
            "lastName": "שם משפחה",
            "lprNumber": "מס' רכב",
            "startDate": "תאריך התחלה",
            "endDate": "תאייך סיום",
            "passportNumber": "ת''ז",
            "companyID": "חברה",
            "title": "מערכת קליטת מנויים"
        },

        "insiteArray": {
            "inside": "inside",
            "free": "free places",
            "whole": "whole",
            "transients": "transients",
            "subscribers": "subscribers",
            "guests": "guests",
            "manuallyOpen": "Manually Open",

            "tag": "tag number",
        },

        "languages": {
            "en": "אנגלית",
            "he": "עברית"
        },
        "errors": {
            "saveSuccess": "נשמר בהצלחה",
            "saveError": "שגיאה בעת שמירה",
            "connectionError": "אין חיבור לשרת",
            "nameError": "שם אינו חוקי",
            "emailError": "מייל אינו חוקי",
            "phoneError": "מס טלפון אינו חוקי",
            "noFirstName": "שם פרטי אינו חוקי",
            "noLastName": "שם משפחה אינו חוקי",
            "noStartDate": "תאריך התחלה אינו חוקי",
            "noLpr": "מספר רכב אינו חוקי",
            "noCompanyId": "שם חברה אינו חוקי"
        },
        "calendar": {
            "previousMonth": "חודשד קודם",
            "nextMonth": "חודש הבא",
            "months": ["ינואר", "פברואר", "מרס", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
            "weekdays": ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
            "weekdaysShort": ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"]
        },
        "getTickets": "Get tickets",
        "virtualValidation": "Virtual Validation",
        "validateTicket": "Validate Ticket",
        "entryTicketNumber": "Entry ticket",
        "transientID": "Transient ID",
        "virtualTicket": "Virtual Ticket",

        "menuSearch": "Menu search",

  }
}
